module.exports = __webpack_public_path__ + "videos/tests-and-surveys.a3515d9.mp4";